import { InputWithLabel, SelectWithLabel } from '@adotel/components'
import {
  Button,
  MenuItem,
  Modal,
  Paper,
  Slide,
  Typography,
  useMediaQuery,
  useTheme
} from '@material-ui/core'
import PolicyIcon from '@material-ui/icons/Policy'
import { useState } from 'react'

import { getDirection, getTranslate } from '../../localization'
import {
  CancelPolicy,
  PolicyTable,
  PolicyPenaltyTypes,
  PolicyType
} from '../../types/cancelAndModifyPolicies'
import useStyles from './styles/PoliciesFormAddPoliciesModal.styles'

interface PoliciesFormAddPoliciesModalProps {
  isOpen: boolean
  onClose: () => void
  values: CancelPolicy
  setFieldValue: (
    field: string,
    value: any,
    shouldValidate?: boolean | undefined
  ) => void
}
const PoliciesFormAddPoliciesModal: React.FC<
  PoliciesFormAddPoliciesModalProps
> = ({ isOpen, onClose, values, setFieldValue }) => {
  const theme = useTheme()
  const classes = useStyles()
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'))
  const [policy, setpolicy] = useState<PolicyTable>({
    deadline: 0,
    deadlineTimeOffset: '00:00',
    penaltyAmount: 0,
    penaltyType: 'FirstNight',
    priority: 1,
    policyType: 'BeforeCheckInTime'
  })

  const convertToPolicyPenaltyTypes = (str: string) => {
    let pp: PolicyPenaltyTypes = 'FirstNight'
    switch (str) {
      case 'FirstNight':
        pp = 'FirstNight'
        break
      case 'TotalStay':
        pp = 'TotalStay'
        break

      default:
        break
    }
    return pp
  }
  const convertToPolicyTypes = (str: string) => {
    let pp: PolicyType = 'BeforeCheckInTime'
    switch (str) {
      case 'BeforeCheckInTime':
        pp = 'BeforeCheckInTime'
        break
      case 'AfterReservationTime':
        pp = 'AfterReservationTime'
        break
      case 'AfterCheckInTime':
        pp = 'AfterCheckInTime'
        break
      case 'BeforeCheckOutTime':
        pp = 'BeforeCheckOutTime'
        break

      default:
        break
    }
    return pp
  }

  const addPolicy = (p: PolicyTable) => {
    setFieldValue('table', [...values.table, p])
  }

  return (
    <Modal
      dir={getDirection()}
      open={isOpen}
      onClose={onClose}
      className={classes.modal}>
      <Slide in={isOpen} direction="down">
        <Paper className={classes.paper}>
          <PolicyIcon className={classes.policyIcon} />
          <div className={classes.header}>
            <Typography variant="h3">
              {getTranslate('Create New Policy')}
            </Typography>
          </div>
          <div className={classes.inputContainer}>
            <InputWithLabel
              inputSize="small"
              label={getTranslate('Priority')}
              value={policy?.priority}
              type="number"
              onChange={(event) =>
                setpolicy({
                  ...policy,
                  priority: parseInt(event.currentTarget.value)
                })
              }
            />
            <InputWithLabel
              inputSize="small"
              label={getTranslate('Penalty Amount')}
              value={policy?.penaltyAmount}
              type="number"
              onChange={(event) =>
                setpolicy({
                  ...policy,
                  penaltyAmount: Math.min(
                    parseInt(event.currentTarget.value),
                    100
                  )
                })
              }
              endIcon={<div>%</div>}
            />
            <SelectWithLabel
              label={getTranslate('Penalty Type')}
              size="small"
              value={policy.penaltyType}
              onChange={(event) =>
                setpolicy({
                  ...policy,
                  penaltyType: convertToPolicyPenaltyTypes(event.target.value)
                })
              }>
              <MenuItem key="Total Stay" value="TotalStay">
                Total Stay
              </MenuItem>
              <MenuItem key="First Night" value="FirstNight">
                First Night
              </MenuItem>
            </SelectWithLabel>
            <SelectWithLabel
              label={getTranslate('Type')}
              size="small"
              value={policy.policyType}
              onChange={(event) =>
                setpolicy({
                  ...policy,
                  policyType: convertToPolicyTypes(event.target.value)
                })
              }>
              <MenuItem key="Before Checkin Time" value="BeforeCheckInTime">
                Before Checkin Time
              </MenuItem>
              <MenuItem
                key="After Reservation Time"
                value="AfterReservationTime">
                After Reservation Time
              </MenuItem>
              <MenuItem key="After Checkin Time" value="AfterCheckInTime">
                After Checkin Time
              </MenuItem>
              <MenuItem key="Before Checkout Time" value="BeforeCheckOutTime">
                Before Checkout Time
              </MenuItem>
            </SelectWithLabel>
            <InputWithLabel
              type="number"
              inputSize="small"
              label={getTranslate('Hours Deadline')}
              value={policy?.deadline}
              onChange={(event) =>
                setpolicy({
                  ...policy,
                  deadline: parseInt(event.currentTarget.value)
                })
              }
            />
            <InputWithLabel
              placeholder={getTranslate('00:00')}
              inputSize="small"
              label={getTranslate('Deadline Time Offset')}
              value={policy?.deadlineTimeOffset}
              onChange={(event) =>
                setpolicy({
                  ...policy,
                  deadlineTimeOffset: event.currentTarget.value
                })
              }
            />
          </div>
          <div className={classes.button}>
            <Button
              variant="outlined"
              color="primary"
              fullWidth={isSmallScreen}
              onClick={() => {
                onClose()
              }}>
              {getTranslate('Cancel')}
            </Button>
            <Button
              variant="contained"
              color="primary"
              fullWidth={isSmallScreen}
              onClick={() => {
                addPolicy(policy)
                onClose()
              }}>
              {getTranslate('Save')}
            </Button>
          </div>
        </Paper>
      </Slide>
    </Modal>
  )
}
export default PoliciesFormAddPoliciesModal
